<template>
  <div @submit.prevent="verify">
    <vs-row class="justify-between">
      <vs-col vs-w="2">
        <div class="items-end px-3 mt-4">
          <feather-icon svgClasses="w-6 h-6" icon="ListIcon" class="mr-2 c-primary" />
          <span class="font-medium text-lg leading-none">Allegati</span>
        </div>
      </vs-col>
      <template v-if="!is_readonly">
        <vs-col v-if="form.length < 5" vs-w="2">
          <div class="append-text btn-addon">
            <vs-button @click="toggleForm = !toggleForm" class="is-label-placeholder w-full" color="success" type="border" icon-pack="feather" icon="icon-plus" />
          </div>
        </vs-col>
        <vs-col v-else vs-w="2">
          <div class="append-text btn-addon text-warning">
            {{['Raggiunto numero massimo allegati',form.length].join(': ')}}
          </div>
        </vs-col>
      </template>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-col vs-w="12" v-if="toggleForm">
        <!-- <FilePickRimborso @input="pushAllegato" v-model="form[form.length + 1]" /> -->
        <FilePickRimborso @input="pushAllegato" />
      </vs-col>
      <vs-col class="white_back mt-4" >
       <vs-table v-if="form.length" max-items="4" :pagination="form.length > 6" :data="form" >
         <template slot="thead">
           <vs-th :key="i" v-for="(e, i) in ['Nome file', 'Data inserimento', '']">{{e}}</vs-th>
         </template>

         <template slot-scope="{data}">
           <!-- <colgroup ref="colgrouptable">
             <col :key="0" :name="`col-0`" width="25%"/>
             <col :key="1" :name="`col-1`" width="25%"/>
             <col :key="2" :name="`col-2`" width="30%"/>
           </colgroup> -->
           <vs-tr class="cursor-arrow" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
             <!-- <vs-td :data="tr[field]" :key="i" v-for="(field, i) in ['name', 'upload_date']">
               {{tr[field]}}
             </vs-td> -->
             <vs-td :key="0">
               {{tr.name}}
             </vs-td>
             <vs-td :key="1">
               {{$tariffe.formatDateNew(tr.upload_date)}}
             </vs-td>
             <vs-td :key:="2">
               <vs-row vs-justify="flex-end" class="m-3">
                 <vs-button @click="getFile(data[indextr], $event)" radius color="warning" type="line" icon-pack="feather" icon="icon-download" />
                 <vs-button v-if="!is_readonly" @click="dropFile(data[indextr].nuovo_nome, $event)" radius color="danger" type="line" icon-pack="feather" icon="icon-trash" />
               </vs-row>
             </vs-td>
           </vs-tr>
         </template>
       </vs-table>
      </vs-col>
 <!--
    like tirocini solution
 -->
      <!-- <vs-col v-for="(doc,idx) in form" class="md:w-6/12 w-full px-2 mt-4" :key="idx">
        <FilePick :label="'Allegato '+(idx+1)" v-model="doc.name" />
      </vs-col> -->

    </vs-row>
  </div>
</template>

<script>
export default {
  props: ['form','is_readonly'],

  data () {
    return {
      toggleForm: false,
      file: null,
      // is_saving: false,
      // conversion_table: {
      //   "Permesso di soggiorno in corso di validità" : "doc_permesso_soggiorno",
      //   "Progetti formativi tirocini precedenti" : "doc_progetti_formativi",
      //   "Documenti INPS per percettori NASPI" : "doc_inps",
      //   "Attestato di Qualifica Professionale" : "doc_attestato_qualifica",
      //   "Curriculum Vitae" : "doc_cv",
      //   "Tessera sanitaria" : "doc_tessera_sanitaria",
      //   "Documento d'identità in corso di validità" : "doc_identita",
      //   "Scheda Anagrafico/Professionale Centro Impiego" : "doc_scheda_anagrafico_professionale",
      //   "Percorso lavoratore rilasciato dal Centro Impiego" : "doc_percorso_lavoratore",
      // }
    }
  },

  // computed: {
  //   az () {
  //     return this.form.azienda
  //   },
  // },

  methods: {
    pushAllegato(item) {
      if (item) {
        this.toggleForm = !this.toggleForm
        this.form.push(item)
      }
    },
    dropFile(id, ev) {
      this.form = this.form.filter(e => e.nuovo_nome != id)
      ev.stopPropagation()
    },
    // validateTemplate() {
    //   console.log('VALIDATE TEMPLATE');
    //   return new Promise((resolve, reject) => {
    //     this.$validator.validateAll('template').then(result => {
    //       if (result) {
    //         // console.log('success');
    //         resolve(true)
    //       } else {
    //         // console.log('failed');
    //         reject("correct all values");
    //       }
    //     })
    //   })
    // },
    // salvaTemplate() {
    //   this.validateTemplate().then(() => {
    //     let formData = new FormData();
    //
    //
    //     // formData.append('file_name', this.selected.file_name);
    //     // formData.append('file_extension', this.selected.file_extension);
    //     // formData.append('nuovo_nome', this.selected.file_name+this.selected.file_extension);
    //
    //     formData.append('file', this.file);
    //
    //     axios.post( process.env.VUE_APP_BACKEND_API + '/tariffa_servizio/upload_default_template',
    //       formData,
    //       {
    //         headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
    //         withCredentials: true,
    //         onUploadProgress: ( progressEvent ) => {
    //           this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
    //         }
    //       }
    //     ).then((r) => {
    //       // console.log('SUCCESS!!', r);
    //       this.$emit('template-salvato', 'OK')
    //     })
    //     .catch((e) => {
    //       console.log(e);
    //     });
    //   })
    // },
    // setVal(v,str) {
    //   this.form[ this.conversion_table[str] ] = v
    //   this.updateTir()
    // },
    // updateTir() {
    //   if (this.form.stato == 'sent') {
    //     this.form.stato_modulo = 0
    //   }
    //   this.$http.post(`modulo-tirocinio/salva?token=${this.form.token}`, this.form)
    // }
    getFile(item) {
      axios.post(process.env.VUE_APP_BACKEND_API+'/rimborso/download', { nome: item.name, nuovo_nome: item.nuovo_nome },{
          headers: { "Access-Control-Allow-Origin": "*", 'Content-Type': 'application/json',},
          withCredentials: true,
          responseType: 'blob'
        })
        .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type:'application/octet-stream'}));
        const link = document.createElement('a');
        link.href = url
        this.$vs.loading.close()
        link.setAttribute('download', response.headers['x-file-name']);
        document.body.appendChild(link);
        link.click();
      })
        .catch(e => console.log(e))
    },
  },
}
</script>

<style lang="scss">
.con-input-upload .text-input {
  font-weight: normal;
  // font-style: italic;
}
</style>
